module.exports = __webpack_public_path__ + "static/img/sy2.f7f5360.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sy2.png
// module id = ujnR
// module chunks = 1